export default __webpack_public_path__ + "static/media/leftsharpT.3f1bae86.png";